export const RESET = 'linkedIncident/RESET';
export const WAITING_FOR_INITIALIZATION = 'linkedIncident/WAITING_FOR_INITIALIZATION';
export const NO_LINKED_INCIDENT = 'linkedIncident/NO_LINKED_INCIDENT';

export const START_LOADING_BY_ID = 'linkedIncident/START_LOADING_BY_ID';
export const START_LOADING_BY_SIDEBAR = 'linkedIncident/START_LOADING_BY_SIDEBAR';
export const START_LOADING_BY_SERVICE = 'linkedIncident/START_LOADING_BY_SERVICE';

export const FINISH_LOADING_BY_ID = 'linkedIncident/FINISH_LOADING_BY_ID';
export const FINISH_LOADING_BY_SIDEBAR = 'linkedIncident/FINISH_LOADING_BY_SIDEBAR';
export const FINISH_LOADING_BY_SERVICE = 'linkedIncident/FINISH_LOADING_BY_SERVICE';

export const reset = () => ({
  type: RESET,
});

export const noLinkedIncident = () => ({
  type: NO_LINKED_INCIDENT,
});

export const startLoadingById = (id) => ({
  type: START_LOADING_BY_ID,
  id,
});

export const startLoadingBySidebar = () => ({
  type: START_LOADING_BY_SIDEBAR,
});

export const startLoadingByService = () => ({
  type: START_LOADING_BY_SERVICE,
});

export const finishLoadingById = (id, incident, error) => ({
  type: FINISH_LOADING_BY_ID,
  id,
  incident,
  error
});

export const finishLoadingBySidebar = (incident, error) => ({
  type: FINISH_LOADING_BY_SIDEBAR,
  incident,
  error
});

export const finishLoadingByService = (incident, error) => ({
  type: FINISH_LOADING_BY_SERVICE,
  incident,
  error
});

export const waitingForInitialization = () => ({
  type: WAITING_FOR_INITIALIZATION
});
